import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import Blank from '../../../hoc/Blank/Blank';
import ContactData from '../../../components/Order/ContactData/ContactData';
import MulchTypes from '../../../components/Order/MulchTypes/MulchTypes';
import OrderTotal from '../../../components/Order/OrderTotal/OrderTotal';
import DeliveryType from '../../../components/Order/DeliveryType/DeliveryType';
import PaymentType from '../../../components/Order/PaymentType/PaymentType';
import OrderButtons from '../../../components/Order/OrderButtons/OrderButtons';
import Modal from '../../../components/UI/Modal/Modal';
import AddOrderErrorModal from '../../../components/ErrorModals/AddOrderErrorModal/AddOrderErrorModal';
import AddOrderSuccessModal from '../../../components/SuccessModals/AddOrderSuccessModal/AddOrderSuccessModal';
import Notes from '../../../components/Order/Notes/Notes';
import * as actions from '../../../store/actions/index';




class AddOrder extends Component {
    state = {
        orderValid: true,
        cancel: false,
        reload: false,
        closeModal: false
    }

    componentDidMount () {
        this.props.onInitOrder();
    }





    validatePage ()  {
        let valid = true;
        valid = valid && this.validateIdentifier('name');
        valid = this.validateIdentifier('address') && valid;
        valid = this.validateIdentifier('city') && valid;
        valid = this.validateIdentifier('zip') && valid;
        valid = this.validateIdentifier('phone') && valid;
        valid = this.validateIdentifier('email') && valid;
        valid = this.validateIdentifier('address') && valid;
        valid = this.validateIdentifier('hardwoodBags') && valid;
        valid = this.validateIdentifier('cedarBags') && valid;
        valid = this.validateIdentifier('blackBags') && valid;
        valid = this.validateIdentifier('redBags') && valid;
        valid = this.validateIdentifier('cashAmount') && valid;
        valid = this.validateIdentifier('checkAmount') && valid;
        valid = this.validateIdentifier('checkNumber') && valid;
    
        if (this.props.order.totalBags === 0)
        {
            this.props.onUpdateOrder('hardwoodBags_touched',true);
            this.props.onUpdateOrder('cedarBags_touched',true);
            this.props.onUpdateOrder('blackBags_touched',true);
            this.props.onUpdateOrder('redBags_touched',true);
            this.props.onUpdateOrder('hardwoodBags_valid',false);
            this.props.onUpdateOrder('cedarBags_valid',false);
            this.props.onUpdateOrder('blackBags_valid',false);
            this.props.onUpdateOrder('redBags_valid',false);
            valid = false;
        }
        
        return valid;
    }


    validateIdentifier (identifier) 
    {
        if (this.props.order[identifier + '_valid'] === false)
        {
            this.props.onUpdateOrder(identifier + '_touched',true);
            return false;
        }
        return true;
    }


    DataChanged = (id,value) => {
        let totalBags = parseInt(this.props.order.blackBags,10) + parseInt(this.props.order.redBags,10) + parseInt(this.props.order.hardwoodBags,10) + parseInt(this.props.order.cedarBags,10);
        let initialBags = totalBags;
        let hardwoodBags = parseInt(this.props.order.hardwoodBags,10);
        let blackBags = parseInt(this.props.order.blackBags,10);
        let cedarBags = parseInt(this.props.order.cedarBags,10);
        let redBags = parseInt(this.props.order.redBags,10);
        if (id === "blackBags") {
            blackBags = value ;
        }
        if (id === "redBags") {
            redBags = value ;
        }
        if (id === "cedarBags") {
            cedarBags = value;
        }
        if (id === "hardwoodBags") {
            hardwoodBags = value;            
        }
        totalBags = parseInt(hardwoodBags,10) + parseInt(blackBags,10) + parseInt(cedarBags,10) + parseInt(redBags,10);        
             
        this.props.onUpdateOrder(id,value);
        if (totalBags !== initialBags)
        {
            let total = 4 * totalBags;
            this.props.onUpdateOrder('totalBags',totalBags);
            this.props.onUpdateOrder('total',total);
        }

    }

    modalCancelHandler = () => {
        this.setState({orderValid: true});
    }

    cancelPageHandler = () => {
        this.props.onInitOrder();
        this.props.history.replace( '/showOrders' );
    }

    submitOrder = () => {
        if (!this.validatePage())
        {
            this.setState({orderValid:false});
        }
        else
        {
            this.setState({orderValid:true});
                        

            let address = this.props.order.address + ',' + this.props.order.city + ' ' + this.props.order.zipCode;


            this.props.onSubmitOrder();
        }
    }    

    AddressChanged = (address,city,zip,geoAddress) => {
        if (geoAddress === this.props.order.geoAddress)
        {            
            return;
        }
        this.props.onUpdateGeoCode(address,city,zip,geoAddress);        
   };


    render () {

        if (!this.props.order) {
            return <Blank />
        }
        
        let modal = null;
        
        if (this.props.purchased) {
            //this.props.onAddOrderToOrders(this.props.order.orderId,this.props.order);
            modal = <AddOrderSuccessModal  addOrderSuccessmodalClosed={this.cancelPageHandler}></AddOrderSuccessModal>
            
        }
        
        if (!this.state.orderValid)
        {
            modal = <AddOrderErrorModal modalClosed={this.modalCancelHandler}/>;
        }
        return (
            <Blank>
                 <Modal show={ modal!= null && !this.state.closeModal} modalClosed={this.modalCancelHandler}>
                    {modal}
                </Modal>
                <Modal show={modal != null && this.state.orderValid} modalClosed={this.cancelPageHandler}>
                    {modal}
                </Modal>
                <ContactData onAddressChanged={this.AddressChanged} 
                    onDataChanged={this.DataChanged}/>
                <MulchTypes
                    onDataChanged={this.DataChanged}/>
                <OrderTotal total={this.props.order.total} totalBags={this.props.order.totalBags}/>
                <DeliveryType  onDataChanged={this.DataChanged}/>
                <Notes  onDataChanged={this.DataChanged}/>
                <PaymentType onDataChanged={this.DataChanged}/>
                <OrderButtons  onOrderSubmitted={this.submitOrder} onOrderCancelled={this.cancelPageHandler}/>
            </Blank>
        );
    }
}


const mapStateToProps = state => {
   
    return {
        order: state.orders.order,        
        isAuthenticated: state.orders.token !== null,
        purchased: state.orders.purchased
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onInitOrder: () => dispatch(actions.initOrder()),
        onUpdateOrder: (id,value) => dispatch(actions.updateOrder(id,value)),
        onUpdateGeoCode:(address,city,zip,geoAddress) => dispatch(actions.updateGeoCode(address,city,zip,geoAddress)),
        onSubmitOrder:() => dispatch(actions.submitOrder()),
        onAddOrderToOrders:(id,orderData) => dispatch(actions.addOrderToOrders(id,orderData))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(AddOrder);


// WEBPACK FOOTER //
// ./src/containers/Orders/AddOrder/AddOrder.js